/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type RateSagasRateQueryVariables = {};
export type RateSagasRateQueryResponse = {
    readonly rateList: {
        readonly rates: ReadonlyArray<{
            readonly rate: string | null;
            readonly stations: ReadonlyArray<{
                readonly station: string | null;
            } | null> | null;
            readonly rates: ReadonlyArray<{
                readonly rateId: number | null;
                readonly groupId: string | null;
                readonly description: string | null;
                readonly unit: string | null;
                readonly price: number | null;
                readonly addUnit: string | null;
                readonly addPrice: number | null;
                readonly kmFree: number | null;
                readonly kmAdd: number | null;
                readonly deductible: number | null;
                readonly inetRate: boolean | null;
            } | null> | null;
        } | null> | null;
    } | null;
};
export type RateSagasRateQuery = {
    readonly response: RateSagasRateQueryResponse;
    readonly variables: RateSagasRateQueryVariables;
};



/*
query RateSagasRateQuery {
  rateList {
    rates {
      rate
      stations {
        station
      }
      rates {
        rateId
        groupId
        description
        unit
        price
        addUnit
        addPrice
        kmFree
        kmAdd
        deductible
        inetRate
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RateList",
    "kind": "LinkedField",
    "name": "rateList",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Rate",
        "kind": "LinkedField",
        "name": "rates",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "RateStation",
            "kind": "LinkedField",
            "name": "stations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "station",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Rate",
            "kind": "LinkedField",
            "name": "rates",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rateId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "groupId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addUnit",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addPrice",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kmFree",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "kmAdd",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "deductible",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "inetRate",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "RateSagasRateQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "RateSagasRateQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "14508ad4cfc808552b56b8f72dc83812",
    "id": null,
    "metadata": {},
    "name": "RateSagasRateQuery",
    "operationKind": "query",
    "text": "query RateSagasRateQuery {\n  rateList {\n    rates {\n      rate\n      stations {\n        station\n      }\n      rates {\n        rateId\n        groupId\n        description\n        unit\n        price\n        addUnit\n        addPrice\n        kmFree\n        kmAdd\n        deductible\n        inetRate\n      }\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '76ff3a4df4555a73aec25e6d9706dc44';
export default node;
